
<template>
  <b-container>
    <div class="loading" v-if="loading">Loading&#8230;</div>
  
    <b-row class="d-flex justify-content-center">
      
      <b-col cols="md-4 mt-4">
        <div class="card mb-4">
          <b-card-header>
            <h6>
              Configuraciones de Moneda
            </h6>            
          </b-card-header>
          <b-card-body>
            <b-form-group>
              <label class="control-label" for="input-live">Separador de decimales</label>
              <b-form-input
                class="form-control"
                id="input-live"
                v-model="configurations.CURRENCY_DECIMAL_SEPARATOR"
                :state="state"
                aria-describedby="input-live-help input-live-feedback"
                placeholder="Nombre de la categoría"
                trim
              ></b-form-input>
              <!-- This will only be shown if the preceding input has an invalid state -->
              <b-form-invalid-feedback v-if="state === false" id="input-live-feedback" >
                El valor debe tener un mínimo de 1 letra
              </b-form-invalid-feedback>
              <!-- This is a form text block (formerly known as help block) -->
              <b-form-text id="input-live-help">Campo obligatorio</b-form-text>
            </b-form-group>

              <b-form-group>
              <label class="control-label" for="input-live">Separador de miles</label>
              <b-form-input
                class="form-control"
                id="input-live"
                v-model="configurations.CURRENCY_THOUSAND_SEPARATOR"
                :state="state"
                aria-describedby="input-live-help input-live-feedback"
                placeholder="Nombre de la categoría"
                trim
              ></b-form-input>
              <!-- This will only be shown if the preceding input has an invalid state -->
              <b-form-invalid-feedback v-if="state === false" id="input-live-feedback" >
                El valor debe tener un mínimo de 1 letra
              </b-form-invalid-feedback>
              <!-- This is a form text block (formerly known as help block) -->
              <b-form-text id="input-live-help">Campo obligatorio</b-form-text>
            </b-form-group>

            <b-form-group>
              <label class="control-label" for="input-live">Cantidad de digitos decimales</label>
              <b-form-input
                class="form-control"
                id="input-live"
                v-model="configurations.CURRENCY_DECIMAL_DIGITS"
                :state="state"
                aria-describedby="input-live-help input-live-feedback"
                placeholder="Nombre de la categoría"
                trim
              ></b-form-input>
              <!-- This will only be shown if the preceding input has an invalid state -->
              <b-form-invalid-feedback v-if="state === false" id="input-live-feedback" >
                El valor debe tener un mínimo de 1 letra
              </b-form-invalid-feedback>
              <!-- This is a form text block (formerly known as help block) -->
              <b-form-text id="input-live-help">Campo obligatorio</b-form-text>
            </b-form-group>
          </b-card-body>
          <div class="card-footer">
            <a v-if="state === null" @click="save()">
              <b-button variant="orange" size="lg">Guardar</b-button>
            </a>
          </div>
        </div>
      </b-col>

      <b-col cols="md-4 mt-4">
        <div class="card mb-4">
          <b-card-header>
            <h6>
              Archivos de certificados de Afip
            </h6>            
          </b-card-header>

          <b-card-body>
            
            <b-form-group>
              <label for="cuit">CUIT</label>
              <b-form-select
                id="cuit"
                v-model="afipCertificates.CUIT"
                :options="cuitOptions"
                required
                placeholder="Seleccione el CUIT"
              ></b-form-select>
              <b-form-text>Campo obligatorio </b-form-text>
            </b-form-group>

            <b-form-group>
              <label for="crtFile">Certificado:</label>
              <input type="file" id="crtFile" @change="handlecrtFile" />
              <b-form-text id="input-live-help">Campo obligatorio - Formato PEM</b-form-text>
            </b-form-group>

             <b-form-group>
                <label for="keyFile">Clave:</label>
                <input type="file" id="keyFile" @change="handleKeyFile" />
            
              <b-form-text id="input-live-help">Campo obligatorio</b-form-text>
            </b-form-group>
          
          </b-card-body>
          <div class="card-footer">
             
          
              <b-form-text v-if="!afipCertificateState"  >
                Error en los campos, por favor verificar
              </b-form-text>

            <a v-if="afipCertificateState" @click="sendCertificateFiles()">
              <b-button variant="orange" size="lg">Enviar</b-button>
            </a>
          </div>
        </div>
      </b-col>


    </b-row>
  </b-container>
</template>

<script>


export default {
 
  data: function() {
    return {
      configurations:{
        CURRENCY_DECIMAL_SEPARATOR:'',
        CURRENCY_DECIMAL_DIGITS:'',
        CURRENCY_THOUSAND_SEPARATOR:''
      },
      afipCertificates:{
        crtFile: null,
        keyFile: null,
        CUIT: '',
      },
       cuitList: [],
      loading: false,
    };
  },
  mounted() {
    this.getConfigurations();
    this.getCuits();
  },
  computed: {
    state() {
      return this.configurations.CURRENCY_DECIMAL_SEPARATOR.length < 1 ||
         this.configurations.CURRENCY_DECIMAL_DIGITS.length < 1 ||
          this.configurations.CURRENCY_THOUSAND_SEPARATOR.length < 1
        ? false
        : null;
    },

    afipCertificateState() {
      return this.afipCertificates.crtFile == null ||
         this.afipCertificates.keyFile == null ||
          this.afipCertificates.CUIT.length != 11
        ? false
        : true;
    },

    cuitOptions() {
      return this.cuitList.map(cuit => ({
        value: cuit,
        text: cuit
      }));
    },

  },
  watch: {
  
  },
  methods: {    
    handlecrtFile(event) {
    this.afipCertificates.crtFile = event.target.files[0];
    },
    handleKeyFile(event) {
      this.afipCertificates.keyFile = event.target.files[0];
    },
    async sendCertificateFiles() {
      this.loading = true;
      try {
  
        // Enviar archivos
        const formData = new FormData();
        formData.append("crt_file", this.afipCertificates.crtFile);
        formData.append("key_file", this.afipCertificates.keyFile);
        formData.append("cuit", this.afipCertificates.CUIT);

        await this.$http.post("/api/configs/upload-afip-certificates", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

      } catch (e) {
        console.error(e);
        alert("Error al subir los archivos");
      }
      this.loading = false;
       alert("Archivos subidos correctamente");
    },

    getConfigurations() {
      var vm = this;
      vm.loading = true
      this.$http.get("/api/configs/getConfigurations").then((response) => {
        vm.configurations = response.data.data;
        vm.loading = false
      });
    },
    getCuits() {
      var vm = this;
      this.$http.get("/api/configs/branchoffice/getCuitList").then((response) => {
        vm.cuitList = response.data.data;
      });
    },

    save() {
      this.loading = true
        this.$http
          .post("/api/configs/updateConfigurations",this.configurations)
          .then((response) => {
            
            console.log(response.data);
            this.getConfigurations();
          });
    },
  },
};
</script>

<style>
  .divActions {
    float: right;
  }
  .marginButton {
    margin-left: 10px;
  }
</style>
